// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1lvL-","inner":"Form_inner__OMBsO","range":"Form_range__2XCwa","name":"Form_name__3asKW","actions":"Form_actions__3dyT-"};